<template>
    <div>
        <l-marker ref="m"
            v-if="user != undefined"
            :lat-lng="latLng"
            @drag="arrowLatLng = $event.latlng"
            @dragend="onmouseup"
            @mousedown="onmousedown"
            @mouseup="onmouseup"
            :zIndexOffset="1501"
            :options="{riseOnHover: true, riseOffset: 3000}"
            :draggable="!anim"
        >
            <l-icon :className="anim ? 'house houseAnim' : loading ? 'house loading' : 'house'">
                <img :src="user.suchStatus == 2 ? require('../assets/map/homecar.svg') : user.suchStatus == 1 ? require('../assets/map/homeuser.svg') : require('../assets/map/homenone.svg')" class="ml-n2 mt-n4" width="40em" height="40em">
            </l-icon>
        </l-marker>
        <l-marker
            v-if="user != undefined && anim || draggable"
            :lat-lng="arrowLatLng ? arrowLatLng : latLng"
            :zIndexOffset="-5"
        >
            <l-icon className="arrow arrowAnim"
                :icon-size="[120,120]"
                :icon-url="require('../assets/map/markerarrows.svg')">
            </l-icon>
        </l-marker>
    </div>
</template>

<script>
import { LMarker, LIcon } from 'vue2-leaflet'
import { mapGetters, mapActions } from 'vuex'
import { setAlert } from '../tools'
import { LatLng } from 'leaflet'
export default {
    name: "UebersichtMarkerPublic",
    components: {
        LMarker,
        LIcon
    },
    computed: {
        ...mapGetters(['user']),
        latLng: function () {
            return {
                lat: this.user.adresse.lat,
                lng: this.user.adresse.lng
            }
        }
    },
    data(){
        return{
            loading: false,
            lastLatLng: [0,0],
            draggable: false,
            mousedown: false,
            anim: false,
            arrowInterval: false,
            mouseTimeout: false,
            arrowLatLng: undefined
        }
    },
    methods: {
        ...mapActions(['putPublicLocation']),
        onmousedown(){
            this.mousedown = true
            this.lastLatLng[0] = this.user.adresse.lat
            this.lastLatLng[1] = this.user.adresse.lng
            this.mouseTimeout = setTimeout(() => {
                if(this.mousedown){
                    this.draggable = true
                    navigator.vibrate(100)
                }
                this.mouseTimeout = false
            }, 1000)
        },
        async onmouseup(e) {
            var msg = this.mouseTimeout ? true : false
            this.mousedown = false
            this.mouseTimeout ? clearTimeout(this.mouseTimeout) : 0
            this.mouseTimeout = false
            if(!this.draggable)
            {
                if(msg)
                    setAlert(this, 'Halte deinen öffentlichen Marker gedrückt bis Pfeile erscheinen, um ihn zu verschieben.', 'Hinweis', 'info')
                this.user.adresse.lat = this.lastLatLng[0]
                this.user.adresse.lng = this.lastLatLng[1]
                this.arrowLatLng = this.user.adresse
                this.$refs.m.mapObject.setLatLng(new LatLng(this.lastLatLng[0], this.lastLatLng[1]))
                this.draggable = false
                return
            }
            this.draggable = false
            this.loading = true
            try {
                await this.putPublicLocation(e.latlng ? e.latlng : e.target._latlng)
                this.arrowLatLng = this.user.adresse
                this.loading = false
                setAlert(this, 'Position wurde geändert.', 'Speichern erfolgreich', 'success')
            }
            catch (err) {
                setAlert(this, err.response.data, 'Speichern fehlgeschlagen', 'danger')
            }
        },
        showArrows(){
            this.anim = true
            setTimeout(() => this.anim = false, 1500)
        }
    },
    mounted(){
        this.showArrows()
    },
    beforeDestroy(){
        clearInterval(this.arrowInterval)
    }
}
</script>
<style>
.arrow{
    opacity:0;
}
.house{
    -webkit-transition: filter .3s;
    -moz-transition: filter .3s;
    -ms-transition: filter .3s;
    -o-transition: filter .3s;
    transition: filter .3s;
    opacity:1;
}
.loading{
    filter: hue-rotate(150deg)
}

.arrowAnim {
  -webkit-animation: fadenshake 1.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadenshake 1.5s; /* Firefox < 16 */
  -ms-animation: fadenshake 1.5s; /* Internet Explorer */
  -o-animation: fadenshake 1.5s; /* Opera < 12.1 */
  animation: fadenshake 1.5s;
}

.houseAnim {
  -webkit-animation: fadenshakeRedux 1.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadenshakeRedux 1.5s; /* Firefox < 16 */
  -ms-animation: fadenshakeRedux 1.5s; /* Internet Explorer */
  -o-animation: fadenshakeRedux 1.5s; /* Opera < 12.1 */
  animation: fadenshakeRedux 1.5s;
}

@keyframes fadenshakeRedux {
    20% { left: 0.3em; top: -0.3em }
    60% { left: 0.3em; top: 0.3em }
    40% { left: -0.3em; top: 0.3em }
    80% { left: -0.3em; top: -0.3em }
}
/* Firefox < 16 */
@-moz-keyframes fadenshakeRedux {
    20% { left: 0.3em; top: -0.3em }
    60% { left: 0.3em; top: 0.3em }
    40% { left: -0.3em; top: 0.3em }
    80% { left: -0.3em; top: -0.3em }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadenshakeRedux {
    20% { left: 0.3em; top: -0.3em }
    60% { left: 0.3em; top: 0.3em }
    40% { left: -0.3em; top: 0.3em }
    80% { left: -0.3em; top: -0.3em }
}

/* Internet Explorer */
@-ms-keyframes fadenshakeRedux {
    20% { left: 0.3em; top: -0.3em }
    60% { left: 0.3em; top: 0.3em }
    40% { left: -0.3em; top: 0.3em }
    80% { left: -0.3em; top: -0.3em }
}

/* Opera < 12.1 */
@-o-keyframes fadenshakeRedux {
    20% { left: 0.3em; top: -0.3em }
    60% { left: 0.3em; top: 0.3em }
    40% { left: -0.3em; top: 0.3em }
    80% { left: -0.3em; top: -0.3em }
}


@keyframes fadenshake {
    10% { opacity: 0.6 }
    20% { left: 1em; top: -1em }
    60% { left: 1em; top: 1em }
    40% { left: -1em; top: 1em }
    80% { left: -1em; top: -1em }
    90% { opacity: 0.6 }
}

/* Firefox < 16 */
@-moz-keyframes fadenshake {
    10% { opacity: 0.6 }
    20% { left: 1em; top: -1em }
    60% { left: 1em; top: 1em }
    40% { left: -1em; top: 1em }
    80% { left: -1em; top: -1em }
    90% { opacity: 0.6 }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadenshake {
    10% { opacity: 0.6 }
    20% { left: 1em; top: -1em }
    60% { left: 1em; top: 1em }
    40% { left: -1em; top: 1em }
    80% { left: -1em; top: -1em }
    90% { opacity: 0.6 }
}

/* Internet Explorer */
@-ms-keyframes fadenshake {
    10% { opacity: 0.6 }
    20% { left: 1em; top: -1em }
    60% { left: 1em; top: 1em }
    40% { left: -1em; top: 1em }
    80% { left: -1em; top: -1em }
    90% { opacity: 0.6 }
}

/* Opera < 12.1 */
@-o-keyframes fadenshake {
    10% { opacity: 0.6 }
    20% { left: 1em; top: -1em }
    60% { left: 1em; top: 1em }
    40% { left: -1em; top: 1em }
    80% { left: -1em; top: -1em }
    90% { opacity: 0.6 }
}
</style>